jQuery(function($){
  
  function open_megamenu(item){
      $('.has-custom-mega').addClass('custom-mega-active');
	  item.addClass('current-mega-link');
    item.find('.custom-megamenu').css("display", "flex").hide().fadeIn("fast");
      //item.find('.custom-megamenu').addClass('show-menu');
    $(':root').addClass('disable-scroll');

  }
  
  function close_megamenu(){
      //$('.has-custom-mega').removeClass('custom-mega-active');
      //item.find('.custom-megamenu').removeClass('show-menu');
      //$('.show-menu').removeClass('show-menu');
      //$('body').removeClass('disable-scroll');
    	$('.has-custom-mega').removeClass('custom-mega-active');
    
     $('.custom-megamenu').fadeOut("fast", function(){
      $(this).removeClass('show-menu');
      
    });
    
    	$('.current-mega-link').removeClass('current-mega-link');
    	$('.show-menu').removeClass('show-menu');
    $(':root').removeClass('disable-scroll');
  }

 
  

    $('.has-custom-mega .site-nav .site-nav--has-dropdown').click(function(e){
        e.preventDefault();

      if(!$('.has-custom-mega').hasClass('custom-mega-active')){
         if($(this).find('.custom-megamenu').length > 0){
            open_megamenu($(this)); 

         }
      }else{
      	close_megamenu();  
      }
      
      $('.custom-megamenu').click(function(e){
      	e.stopPropagation();
      });
    });

  $('.close-btn').click(function(e){
   	close_megamenu(); 
    
  });
  
  var origImg = $('.custom-megamenu .image-col img').attr("src");

  $('.custom-megamenu .custom-mega-item:not(last-child)').hover(function(){
	  var imgSrc = $(this).data("image");
     
      $('.custom-megamenu .item-img').attr("src", imgSrc);
      $('.custom-megamenu .image-col').addClass('active-hover');

    
      setTimeout(function(){
        $('.custom-megamenu .image-col .item-img').addClass('is-visible');
      }, 100);
    
    
  }, function(){
	
   
      setTimeout(function(){
         $('.custom-megamenu .image-col .item-img').removeClass('is-visible');

      }, 100);
    
     $('.custom-megamenu .image-col').removeClass('active-hover');

    
    
  });

});